import React, { useEffect, useState, useContext, useCallback } from 'react'
import { Table, Button, Row, Col, Modal, Spinner } from 'react-bootstrap';
import { getPayments, getAccountTypeDisplayName, refundPayment, approveOfflinePayment } from './PaymentHistoryService'
import { SecurityContext } from '../../security/SecurityContext';
import { TenantContext } from '../../tenant/TenantContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileInvoice, faArrowRight, faArrowLeft, faFileExcel, faFilePdf, faEnvelope, faMoneyBillTransfer, faTrash, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons'
import { evenRound } from 'util/NumberUtils';
import { formatCurrency } from 'util/Currency';
import { formatDate, formatDateToYYYYMMDD, stringToDateBeginningOfDayUTC, stringUTCToLocal, stringToDateEndOfDayUTC, stringUTCToLocalString } from 'util/Date';
import { getPaymentStatus } from 'util/Lookup';
import _ from "lodash";
import { extractError } from 'api/ErrorUtil';
import { API } from '../../api/API';
import {
    PAYMENT_RECPT_DOWNLOAD, PAGE_SIZE, PAYMENTS_HISTORY_DOWNLOAD,
    CURRENT_YEAR_STATEMENT_DOWNLOAD, PREV_YEAR_STATEMENT_DOWNLOAD
} from '../../config/config';
import { useNavigate } from 'react-router-dom';
import { FormContainer } from 'uiwidgets/FormContainer';
import { FormField } from 'uiwidgets/FormField';
import { containsAlphaNumAndSpaceOnly, isValidDate } from 'util/Validators';
import { getPaymentSourceType } from 'util/Lookup';
import { SubmitButton } from 'uiwidgets/SubmitButton';

const PaymentHistoryPage = () => {

    const initialFilterDate = {
        keyword: "",
        fromPaymentDate: "",
        toPaymentDate: "",
        paymentStatus: ""
    }

    const initialFilterValidityData = {
        keywordError: false,
        keywordErrMsg: "",
        fromPaymentDateError: false,
        fromPaymentDateErrMsg: "",
        toPaymentDateError: false,
        toPaymentDateErrMsg: "",
        paymentStatusError: "",
        paymentStatusErrMsg: ""
    }

    const initialApprovePaymentFormData = {
        paymentDate: formatDateToYYYYMMDD(new Date()),
        receiptDate: formatDateToYYYYMMDD(new Date()),
    }

    const initialApprovePaymentFormValidityData = {
        paymentDateError: false,
        paymentDateErrMsg: "",
        receiptDateError: false,
        receiptDateErrMsg: ""
    }

    const [approvePaymentFormData, setApprovePaymentFormData] = useState(initialApprovePaymentFormData)
    const [approvePaymentFormValidityData, setApprovePaymentFormValidityData] = useState(initialApprovePaymentFormValidityData)

    const [payments, setPayments] = useState({});
    const [errors, setErrors] = useState("");
    const [infoMessage, setInfoMessage] = useState("");
    const [refundProcessed, setRefundProcessed] = useState("");
    const [filterData, setFilterData] = useState(initialFilterDate);
    const [filterValidityData, setFilterValidityData] = useState(initialFilterValidityData);
    const [processingPaymentId, setProcessingPaymentId] = useState(null);
    const secCtx = useContext(SecurityContext);
    const { businessConfig } = useContext(TenantContext);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
    const [showCorrespondence, setShowCorrespondence] = useState({ show: false, correspondence: "" });


    const handleCorrespondenceClose = () => setShowCorrespondence({ show: false, correspondence: "" });
    const handleCorrespondenceShow = (event, correspondence) => {
        setShowCorrespondence({ show: true, correspondence: correspondence });
    }

    const onToastClose = () => {
        setErrors({});
        setInfoMessage("");
    }

    const [showApprovePayment, setShowApprovePayment] = useState({ show: false, payment: {} });
    const handleApprovePaymentClose = () => {
        setShowApprovePayment({ show: false, payment: {} });
    }
    const handleApprovePaymentShow = async (event, payment) => {
        setShowApprovePayment({ show: true, payment: payment });
    }

    const fetchPaymentsForce = useCallback(async () => {
        console.log("fetch payments force");
        try {
            let blPmnts = await getPayments({ page: currentPage, size: PAGE_SIZE });
            setPayments(blPmnts.content);
            setTotalNumberOfPages(blPmnts.totalPages);
            setCurrentPage(0);
            setFilterData(initialFilterDate);
            setFilterValidityData(initialFilterValidityData);
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setInfoMessage("Payments were not found!");
                setPayments([]);
            } else {
                setErrors({ message, errors, httpStatus });
            }
        }

    });

    const fetchPayments = useCallback(async (filter) => {
        let blPmnts = null;
        try {
            console.log("fetch payments filter true");
            blPmnts = await getPayments({
                page: currentPage, size: PAGE_SIZE, keyword: filterData.keyword.trim(),
                fromPaymentDate: filterData.fromPaymentDate ? stringToDateBeginningOfDayUTC(filterData.fromPaymentDate) : "",
                toPaymentDate: filterData.toPaymentDate ? stringToDateEndOfDayUTC(filterData.toPaymentDate) : "",
                paymentStatus: filterData.paymentStatus
            });
            setPayments(blPmnts.content);
            setTotalNumberOfPages(blPmnts.totalPages);

        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setInfoMessage("Payments were not found!");
                setPayments([]);
            } else {
                setErrors({ message, errors, httpStatus });
            }
        }
    }
    );

    useEffect(() => {
        console.log("Fetching payments for current page")
        fetchPayments();
    }, [currentPage]);

    useEffect(() => {
        if (filterData.keyword.length > 3) {
            console.log("Fetching payments for filter grater than 3")
            fetchPayments();
        }
    }, [filterData.keyword]);

    useEffect(() => {
        console.log("Fetching payments for payment status")
        fetchPayments();
    }, [filterData.paymentStatus]);

    useEffect(() => {
        if (filterData.fromPaymentDate && filterData.toPaymentDate) {
            console.log("Fetching payments for payment date filter")
            fetchPayments();
        }
    }, [filterData.toPaymentDate, filterData.fromPaymentDate]);

    useEffect(() => {
        //without this condition payment are fetched
        //a second time in addition to the above useeffect
        if (refundProcessed) {
            console.log("Fetching payments for refund")
            fetchPaymentsForce();
        }
    }, [refundProcessed])

    const handleFilterKeyDown = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            fetchPayments();
        }
    };
    const clearFilter = async (event) => {
        fetchPaymentsForce();
    };

    let downloadFile = async (evt, url, id) => {
        evt.preventDefault();
        await API.get(url + "/" + id, { responseType: "blob" })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "receipt.pdf");
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                let { message, errors, httpStatus } = extractError(err);
                if (httpStatus === 404) {
                    setErrors({ message: "Unable to download receipt at this time!" });
                } else {
                    setErrors({ message, errors, httpStatus });
                }
            });
    };

    const handleChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFilterData({
            ...filterData,
            [name]: value
        })
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFilterValidityData({
            ...filterValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }


    const handleApprovePaymentFormChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setApprovePaymentFormData({
            ...approvePaymentFormData,
            [name]: value
        })
    }

    const handleApprovePaymentFormValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setApprovePaymentFormValidityData({
            ...approvePaymentFormValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "keyword":
                if (value.trim() === "") {
                    hasError = false
                    error = ""
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid keyword. Only alphanumeric characters are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "fromPaymentDate":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "From Payment Date is invalid"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            case "toPaymentDate":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "To Payment Date is invalid"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            case "paymentDate":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "Payment Date is invalid"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            case "receiptDate":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "Receipt Date is invalid"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            default:
                break;
        }
        return { hasError, error };
    }

    const goToHistoryDetail = async (event, payment) => {
        event.preventDefault();
        navigate('/payment-history/' + payment.id);
    }

    const handlePaging = async (page) => {
        if (page < 0) {
            alert("Reached the beginning of data set")
            page = 0;
        }
        if (page > totalNumberOfPages - 1) {
            alert("Reached the end of data set")
            page = totalNumberOfPages - 1;
        }
        setCurrentPage(page);
    }

    const downloadHistoryExcel = async (evt) => {
        evt.preventDefault();
        await API.get(PAYMENTS_HISTORY_DOWNLOAD, { responseType: "blob" })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "PaymentHistory.xlsx");
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                let { message, errors, httpStatus } = extractError(err);
                if (httpStatus === 404) {
                    setInfoMessage("No Payments were found for download as excel!");
                } else {
                    setErrors({ message, errors, httpStatus });
                }
            });

    }

    const downloadYearlyStatement = async (evt, url) => {
        evt.preventDefault();
        await API.get(url, { responseType: "blob" })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'YearlyStatement.pdf';
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (fileNameMatch.length === 2)
                        fileName = fileNameMatch[1];
                }

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                let { message, errors, httpStatus } = extractError(err);
                if (httpStatus === 404) {
                    setInfoMessage("No Payments were found for download as excel!");
                } else {
                    setErrors({ message, errors, httpStatus });
                }
            });

    };

    const processRefund = async (event, payment) => {
        try {
            let confirmRefund = window.confirm("Are you sure you want to refund payment bearing the transaction number:" + payment.transactionNumber);
            if (!confirmRefund) {
                return false;
            }
            setProcessingPaymentId(payment.id);
            let refundResp = await refundPayment(payment.id);
            setInfoMessage("Refund was successful. Refund confirmation number:" + refundResp.refundNumber);
            setProcessingPaymentId(null);
            setRefundProcessed(Date.now());
        } catch (error) {
            setProcessingPaymentId(null);
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setErrors({ message: "Payment was not found!" });
            } else {
                setErrors({ message, errors, httpStatus });
            }
        }
    }

    const approvePayment = async (event, payment, paymentStatus) => {
        try {
            event.preventDefault();
            setProcessingPaymentId(payment.id);

            if (paymentStatus == 'PAYMENT_DECLINED') {
                let confirmDecline = window.confirm("Are you sure you want to decline payment bearing the transaction number: " + payment.transactionNumber +
                    ". Please note, recurring payments and sponsorships associated with the payment will not be deleted. " +
                    "If this is not a one time decline and you need to delete recurring payments and sponsorships. use the appropriate screens");
                if (!confirmDecline) {
                    setInfoMessage("Payment decline was cancelled.");
                    setProcessingPaymentId(null);
                    setRefundProcessed(Date.now())
                    return false;
                }
            } else {
                let confirmApprove = window.confirm("Are you sure you want to approve payment bearing the transaction number:" + payment.transactionNumber);
                if (!confirmApprove) {
                    setInfoMessage("Payment approval was cancelled.");
                    setProcessingPaymentId(null);
                    setRefundProcessed(Date.now())
                    return false;
                }
            }

            await approveOfflinePayment(payment.id, approvePaymentFormData.paymentDate,
                approvePaymentFormData.receiptDate, paymentStatus);

            if (paymentStatus == 'PAYMENT_DECLINED') {
                setInfoMessage("Payment decline was successful.");
            } else {
                setInfoMessage("Payment approval was successful.");
            }
            setProcessingPaymentId(null);
            setRefundProcessed(Date.now())
            handleApprovePaymentClose();
        } catch (error) {
            setProcessingPaymentId(null);
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setErrors({ message: "Payment was not found!" });
            } else {
                setErrors({ message, errors, httpStatus });
            }
        }
    }

    const getDistinctAccountTypes = (accounts) => {
        if (!accounts) {
            return [];
        }
        let distinctAccTypes = [...new Set(accounts.map(account => account.accountTypeId))];
        let accountTypeNames = []
        for (let accountTypeId of distinctAccTypes) {
            accountTypeNames.push(getAccountTypeDisplayName(accountTypeId, businessConfig.accountTypes));
        }
        return accountTypeNames;
    }
    return (
        <>
            <FormContainer title="Payment History" toastCloseFunc={onToastClose} errors={errors} infoMessage={infoMessage} >
                <Row>
                    <Col sm={12} md={4} lg={4}>
                        <FormField name="keyword" label="Keyword" type="text" value={filterData.keyword}
                            placeholder="Receipt Number, Transaction Number, email" onChange={handleChange}
                            onBlur={handleValidation} onKeyDown={handleFilterKeyDown}
                            valstate={!filterValidityData.keywordError} valMsg={filterValidityData.keywordErrMsg} />
                    </Col>
                    <Col sm={6} md={2} lg={2}>
                        <FormField name="paymentStatus" label="Payment Status" type="select" value={filterData.paymentStatus}
                            placeholder="Payment Status" onChange={handleChange} onBlur={handleValidation}
                            valstate={!filterValidityData.paymentStatusError} valMsg={filterValidityData.paymentStatusErrMsg}>
                            <option value="">Select a payment status</option>
                            <option value="PAYMENT_SUCCEEDED">{getPaymentStatus("PAYMENT_SUCCEEDED")}</option>
                            <option value="PAYMENT_FAILED">{getPaymentStatus("PAYMENT_FAILED")}</option>
                            <option value="PAYMENT_DECLINED">{getPaymentStatus("PAYMENT_DECLINED")}</option>
                            <option value="PAYMENT_REFUNDED">{getPaymentStatus("PAYMENT_REFUNDED")}</option>
                            <option value="PAYMENT_PENDING_APPROVAL">{getPaymentStatus("PAYMENT_PENDING_APPROVAL")}</option>
                        </FormField>
                    </Col>
                    <Col sm={6} md={2} lg={2}>
                        <FormField name="fromPaymentDate" label="From Payment Date" type="date" value={filterData.fromPaymentDate}
                            placeholder="Enter From Date" onChange={handleChange} onBlur={handleValidation}
                            valstate={!filterValidityData.fromPaymentDateError} valMsg={filterValidityData.fromPaymentDateErrMsg} />
                    </Col>
                    <Col sm={6} md={2} lg={2}>
                        <FormField name="toPaymentDate" label="To Payment Date" type="date" value={filterData.toPaymentDate}
                            placeholder="Enter To Date" onChange={handleChange} onBlur={handleValidation}
                            valstate={!filterValidityData.toPaymentDateError} valMsg={filterValidityData.toPaymentDateErrMsg} />
                    </Col>
                    <Col sm={6} md={2} lg={2}>
                        <br />
                        <Button variant="info" className="border-0 btn-fill" onClick={clearFilter}><strong><small>Clear Filter</small></strong></Button>
                    </Col>
                </Row>
                {!_.isEmpty(payments) &&
                    <React.Fragment>
                        <Row>
                            <Col className='d-flex justify-content-begin'>
                                <Button variant="dark" className="border-0 text-dark" onClick={(event) => { downloadHistoryExcel(event) }}>
                                    <h6><FontAwesomeIcon icon={faFileExcel} />Download History</h6>
                                </Button>
                                &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { downloadYearlyStatement(event, PREV_YEAR_STATEMENT_DOWNLOAD) }}>
                                    <h6><FontAwesomeIcon icon={faFilePdf} />Previous Year Statement</h6>
                                </Button>
                                &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { downloadYearlyStatement(event, CURRENT_YEAR_STATEMENT_DOWNLOAD) }}>
                                    <h6><FontAwesomeIcon icon={faFilePdf} />Current Year Statement</h6>
                                </Button>
                            </Col>
                            <Col className='d-flex justify-content-end'>
                                <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage - 1) }}>
                                    <h6><FontAwesomeIcon icon={faArrowLeft} />Previous Page</h6>
                                </Button>
                                &nbsp;<span className="border-0 text-dark btn"><h6>{currentPage + 1} of {totalNumberOfPages}</h6></span>
                                &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage + 1) }}>
                                    <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
                                </Button>
                            </Col>
                        </Row>
                    </React.Fragment>}
                <Table className="table-hover table-striped">
                    <thead>
                        <tr>
                            <th className="border-0">Payment Amount</th>
                            <th className="border-0">Payment Date</th>
                            <th className="border-0">Transaction Number</th>
                            <th className="border-0">Receipt Number</th>
                            <th className="border-0">Payment Status</th>
                            <th className="border-0">Payment Method</th>
                            <th className="border-0">Account</th>
                            {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")
                                && <React.Fragment>
                                    <th className="border-0">Payer Email</th>
                                    <th className="border-0">Payer Message</th>
                                    
                                    <th className="border-0">Approve</th>

                                </React.Fragment>}
                            <th className="border-0">Details</th>
                            <th className="border-0">Receipt</th>
                            {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")
                                &&<th className="border-0">Refund</th>}

                        </tr>
                    </thead>
                    <tbody>
                        {!_.isEmpty(payments) && payments.map((payment, idx) => (
                            <tr key={idx} style={payment.status === 'PAYMENT_REFUNDED' ? { backgroundColor: 'yellow' } : {}}>
                                <td>{formatCurrency(evenRound(payment.paymentAmount / 100, 2), businessConfig.locale, businessConfig.currency)}</td>
                                <td>{formatDate(stringUTCToLocal(payment.paymentDate))}</td>
                                <td>{payment.transactionNumber}</td>
                                <td>{payment.receiptNumber}</td>
                                <td>{getPaymentStatus(payment.status)}</td>
                                <td>{getPaymentSourceType(payment.paymentSourceType)}</td>
                                <td>
                                    {getDistinctAccountTypes(payment.accounts).map((accountType, idx1) => (
                                        <span key={idx1}>
                                            {/*getAccountNumber(secCtx.accounts, commitment.accountId)*/}
                                            {accountType}<br />
                                        </span>
                                    ))}
                                </td>

                                {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")
                                    && <React.Fragment>
                                        <td className='text-left'>{payment.payingUserEmail}</td>
                                        <td className='text-left'>
                                            {payment.correspondence && <Button variant='dark' className='border-0 text-dark' onClick={event => handleCorrespondenceShow(event, payment.correspondence)}>
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </Button>}
                                        </td>
                                        <td className='text-left'>
                                            {(processingPaymentId === payment.id && payment.status === 'PAYMENT_PENDING_APPROVAL') ? (
                                                <Spinner
                                                    style={{ marginBottom: 27 }}
                                                    animation="border"
                                                    variant="success"
                                                />) : (<>
                                                    {(payment.status === 'PAYMENT_PENDING_APPROVAL') && <>
                                                        <nobr>
                                                            <Button variant="dark" className="border-0 text-dark" onClick={evt => handleApprovePaymentShow(evt, payment)}>
                                                                <FontAwesomeIcon icon={faThumbsUp} color="green" title="approve" />
                                                            </Button>
                                                            <Button variant="dark" className="border-0 text-dark" onClick={evt => approvePayment(evt, payment, 'PAYMENT_DECLINED')}>
                                                                <FontAwesomeIcon icon={faThumbsDown} color="red" title="decline" />
                                                            </Button>
                                                        </nobr>

                                                    </>}</>)}
                                        </td>
                                    </React.Fragment>}


                                <td><Button variant="dark" className="border-0 text-dark" onClick={evt => goToHistoryDetail(evt, payment)}>
                                    <FontAwesomeIcon icon={faFileInvoice} />
                                </Button>
                                </td>
                                <td>{((payment.status === 'PAYMENT_SUCCEEDED') || (payment.status === 'PAYMENT_REFUNDED')) && <Button variant="dark" className="border-0 text-dark" onClick={evt => downloadFile(evt, PAYMENT_RECPT_DOWNLOAD, payment.id)}>
                                    <FontAwesomeIcon icon={faDownload} />
                                </Button>}</td>
                                {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")
                                && <td className='text-left'>
                                    {(processingPaymentId === payment.id && payment.status === 'PAYMENT_SUCCEEDED') ? (
                                        <Spinner
                                            style={{ marginBottom: 27 }}
                                            animation="border"
                                            variant="success"
                                        />) : (<>
                                            {(payment.status === 'PAYMENT_SUCCEEDED') &&
                                                <Button variant="dark" className="border-0 text-dark" onClick={evt => processRefund(evt, payment)}>
                                                    <FontAwesomeIcon icon={faMoneyBillTransfer} />
                                                </Button>}</>)}
                                </td>}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </FormContainer>
            <Modal show={showCorrespondence.show} onHide={handleCorrespondenceClose}>
                <Modal.Header closeButton>Payers Message</Modal.Header>
                <Modal.Body>
                    {showCorrespondence.correspondence}
                </Modal.Body>
            </Modal>
            <Modal show={showApprovePayment.show} onHide={handleApprovePaymentClose}>
                <Modal.Header closeButton><b>Approve Payment</b></Modal.Header>
                <Modal.Body>
                    <FormContainer title="Approve Payment"
                        submitButtonFunction={event => approvePayment(event, showApprovePayment.payment, 'PAYMENT_SUCCEEDED')}>

                        <FormField name="paymentDate" label="Payment Date" type="date" value={approvePaymentFormData.paymentDate}
                            placeholder="Payment Date" onChange={handleApprovePaymentFormChange} onBlur={handleApprovePaymentFormValidation}
                            valstate={!approvePaymentFormValidityData.paymentDateError} valMsg={approvePaymentFormValidityData.paymentDateErrMsg}
                            readOnly={approvePaymentFormData.readOnly} />

                        <FormField name="receiptDate" label="Receipt Date" type="date" value={approvePaymentFormData.receiptDate}
                            placeholder="Receipt Date" onChange={handleApprovePaymentFormChange} onBlur={handleApprovePaymentFormValidation}
                            valstate={!approvePaymentFormValidityData.receiptDateError} valMsg={approvePaymentFormValidityData.receiptDateErrMsg}
                            readOnly={approvePaymentFormData.readOnly} />
                        <br />
                        <SubmitButton label="Approve Payment" />
                    </FormContainer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PaymentHistoryPage